import { SUPABASE_PROJECT_ID, DEV_PROJECT_ID, PROD_PROJECT_ID } from '@/integrations/supabase/client';

/**
 * Renders a non-obtrusive banner at the top of the viewport when the app is
 * running in dev mode or is pointed at a non-production database.
 * Invisible in production builds pointing at prod.
 */
export function DevDbBanner() {
  const isDev = import.meta.env.DEV;
  const isDevDb = SUPABASE_PROJECT_ID === DEV_PROJECT_ID;
  const isProdDb = SUPABASE_PROJECT_ID === PROD_PROJECT_ID;

  // Invisible: prod build pointing at prod DB
  if (!isDev && isProdDb) return null;

  const label = isDevDb ? 'DEV DB' : isProdDb ? 'PROD DB' : `DB: ${SUPABASE_PROJECT_ID ?? 'unknown'}`;
  const color = isProdDb
    ? 'bg-red-600 text-white'     // any non-prod build hitting prod — red alert
    : 'bg-amber-400 text-black';  // dev build hitting dev DB — amber info

  return (
    <div className={`fixed top-0 left-1/2 -translate-x-1/2 z-[9999] px-3 py-0.5 text-[11px] font-mono font-bold rounded-b-md shadow ${color}`}>
      {label}
    </div>
  );
}
